module.exports = __webpack_public_path__ + "img/strip-23.7edef048.jpg";